import { Instance } from 'mobx-state-tree';
import { VisitDeletedDtoModelBase } from './VisitDeletedDtoModel.base';

/* The TypeScript type of an instance of VisitDeletedDtoModel */
export interface VisitDeletedDtoModelType extends Instance<typeof VisitDeletedDtoModel.Type> {}

/* A graphql query fragment builders for VisitDeletedDtoModel */
export { selectFromVisitDeletedDto, visitDeletedDtoModelPrimitives, VisitDeletedDtoModelSelector } from './VisitDeletedDtoModel.base';

/**
 * VisitDeletedDtoModel
 */
export const VisitDeletedDtoModel = VisitDeletedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
